import * as Sentry from "@sentry/vue";
import type { App } from "vue";
import type { Router } from "vue-router";

/**
 * Initialize Sentry for the mobile app. No-ops if `VITE_SENTRY_DSN` is
 * unset so the integration is inert until the user provides a DSN.
 */
export function initSentry(app: App, router: Router): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) {
    console.info("sentry: DSN not set; skipping init");
    return;
  }
  Sentry.init({
    app,
    dsn,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration({ router })
    ],
    tracesSampleRate: 0.0, // off for beta — enable later if needed
    sendDefaultPii: false,
    beforeSend(event) {
      // Strip anything in event.request that could contain PII.
      if (event.request) {
        delete event.request.data;
        delete event.request.cookies;
      }
      return event;
    }
  });
  console.info("sentry: initialized");
}
